import { render } from "./GoogleSignInButton.vue?vue&type=template&id=8b70e564&scoped=true"
import script from "./GoogleSignInButton.vue?vue&type=script&lang=js"
export * from "./GoogleSignInButton.vue?vue&type=script&lang=js"

import "./GoogleSignInButton.vue?vue&type=style&index=0&id=8b70e564&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b70e564"]])

export default __exports__